import PropTypes from "prop-types";
import { Children } from "react";
import classnames from "classnames";
import styles from "../index.css";
import {
  HORIZONTAL_SCROLL_MASK_BOTH,
  HORIZONTAL_SCROLL_MASK_LEFT,
  HORIZONTAL_SCROLL_MASK_RIGHT,
  useHorizontalScrollMask,
} from "../../hooks/useHorizontalScrollMask";

export const ListElement = ({
  listRef,
  children,
  scrollSnapping,
  showCarousel,
}) => {
  const childCount = Children.count(children);
  const { maskState } = useHorizontalScrollMask(listRef, [childCount]);

  return (
    <ul
      ref={listRef}
      data-horizontal-scroll-list-list="true"
      className={classnames(styles.list, {
        [styles.scrollSnapping]: scrollSnapping,
        [styles.maskLeft]: maskState === HORIZONTAL_SCROLL_MASK_LEFT,
        [styles.maskRight]: maskState === HORIZONTAL_SCROLL_MASK_RIGHT,
        [styles.maskBoth]: maskState === HORIZONTAL_SCROLL_MASK_BOTH,
      })}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={showCarousel ? 0 : undefined}
    >
      {children}
    </ul>
  );
};

ListElement.propTypes = {
  listRef: PropTypes.object,
  children: PropTypes.node,
  scrollSnapping: PropTypes.bool,
  showCarousel: PropTypes.bool,
};
